module.exports = __webpack_public_path__ + "static/media/fe.6da214ec.jpg";